const SupportEmail = () => {
    return <div className='lykio-support-footer'>Need help? Email us at <a href="mailto:someone@whatever.com">someone@whatever.com</a>.<br></br></div>
}

export default SupportEmail;